/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/patient/patient.resolver.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Injectable } from "@angular/core";
import { VisionIcsApiService, } from "vics/visionics/api/ng/index";
import * as i0 from "@angular/core";
import * as i1 from "vics/visionics/api/ng/index";
export class PatientResolver {
    /**
     * @param {?} api
     */
    constructor(api) {
        this.api = api;
    }
    /**
     * @param {?} route
     * @return {?}
     */
    resolve(route) {
        return this.api.readPatient(route.params.id);
    }
    ;
}
PatientResolver.decorators = [
    { type: Injectable, args: [{ providedIn: "root" },] },
];
/** @nocollapse */
PatientResolver.ctorParameters = () => [
    { type: VisionIcsApiService }
];
/** @nocollapse */ PatientResolver.ɵfac = function PatientResolver_Factory(t) { return new (t || PatientResolver)(i0.ɵɵinject(i1.VisionIcsApiService)); };
/** @nocollapse */ PatientResolver.ɵprov = i0.ɵɵdefineInjectable({ token: PatientResolver, factory: PatientResolver.ɵfac, providedIn: "root" });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(PatientResolver, [{
        type: Injectable,
        args: [{ providedIn: "root" }]
    }], function () { return [{ type: i1.VisionIcsApiService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    PatientResolver.prototype.api;
    /* Skipping unhandled member: ;*/
}
export class ScreeningResultResolver {
    /**
     * @param {?} api
     */
    constructor(api) {
        this.api = api;
    }
    /**
     * @param {?} route
     * @return {?}
     */
    resolve(route) {
        return this.api.listScreeningResult(route.params.id);
    }
    ;
}
ScreeningResultResolver.decorators = [
    { type: Injectable, args: [{ providedIn: "root" },] },
];
/** @nocollapse */
ScreeningResultResolver.ctorParameters = () => [
    { type: VisionIcsApiService }
];
/** @nocollapse */ ScreeningResultResolver.ɵfac = function ScreeningResultResolver_Factory(t) { return new (t || ScreeningResultResolver)(i0.ɵɵinject(i1.VisionIcsApiService)); };
/** @nocollapse */ ScreeningResultResolver.ɵprov = i0.ɵɵdefineInjectable({ token: ScreeningResultResolver, factory: ScreeningResultResolver.ɵfac, providedIn: "root" });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(ScreeningResultResolver, [{
        type: Injectable,
        args: [{ providedIn: "root" }]
    }], function () { return [{ type: i1.VisionIcsApiService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    ScreeningResultResolver.prototype.api;
    /* Skipping unhandled member: ;*/
}
export class FollowUpResolver {
    /**
     * @param {?} api
     */
    constructor(api) {
        this.api = api;
    }
    /**
     * @param {?} route
     * @return {?}
     */
    resolve(route) {
        return this.api.listFollowUp(route.params.id);
    }
    ;
}
FollowUpResolver.decorators = [
    { type: Injectable, args: [{ providedIn: "root" },] },
];
/** @nocollapse */
FollowUpResolver.ctorParameters = () => [
    { type: VisionIcsApiService }
];
/** @nocollapse */ FollowUpResolver.ɵfac = function FollowUpResolver_Factory(t) { return new (t || FollowUpResolver)(i0.ɵɵinject(i1.VisionIcsApiService)); };
/** @nocollapse */ FollowUpResolver.ɵprov = i0.ɵɵdefineInjectable({ token: FollowUpResolver, factory: FollowUpResolver.ɵfac, providedIn: "root" });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(FollowUpResolver, [{
        type: Injectable,
        args: [{ providedIn: "root" }]
    }], function () { return [{ type: i1.VisionIcsApiService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    FollowUpResolver.prototype.api;
    /* Skipping unhandled member: ;*/
}
//# sourceMappingURL=data:application/json;base64,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